module.exports = __webpack_public_path__ + "img/pitching.fee9eb41.jpg";